import type { SentenceEntry } from "./types";

export function getSentenceIntentIds(sentence: SentenceEntry): string[] {
  return Array.from(new Set([
    sentence.intent,
    sentence.sourceIntentId,
    ...(sentence.sourceIntentIds || []),
  ].map((intentId) => String(intentId || "").trim()).filter(Boolean)));
}

export function sentenceBelongsToIntent(
  sentence: SentenceEntry,
  intentId: string,
): boolean {
  const normalizedIntentId = String(intentId || "").trim();
  return Boolean(normalizedIntentId) && getSentenceIntentIds(sentence).includes(normalizedIntentId);
}
